import StakeholdersGet from './Get';
import StakeholdersCreate from './Create';
import StakeholdersCreateFromUsers from './CreateFromUsers';
import StakeholdersCreateWalletType from './CreateWalletType';
import StakeholdersCreatePspType from './CreatePspType';
import StakeholdersUpdate from './Update';
import StakeholdersUpdateWalletType from './UpdateWalletType';
import StakeholdersUpdatePspType from './UpdatePspType';
import StakeholdersChangeStatus from './ChangeStatus';
import StakeholdersShopsInfo from './ShopsInfo';
import GatewayStakeholdersList from './gateway/Stakeholders';
import GatewayAllotmentList from './gateway/Allotment';

export {
    StakeholdersGet,
    StakeholdersCreate,
    StakeholdersCreateFromUsers,
    StakeholdersCreateWalletType,
    StakeholdersCreatePspType,
    StakeholdersUpdate,
    StakeholdersUpdateWalletType,
    StakeholdersUpdatePspType,
    StakeholdersChangeStatus,
    StakeholdersShopsInfo,
    GatewayStakeholdersList,
    GatewayAllotmentList,
}
